export const TEST_ID = 'sectionEyebrow';
